<template>
	<section class="blocks" :class="bg_resp_color" id="block5" :style="{ backgroundImage: 'url(' + figure + ')' }">
		<div class="container">
			<h2 class="title-box left">{{ title }}</h2>
			<article v-html="content">
				{{ content }}
			</article>

			<figure class="mobile">
				<img :src="resp_image" :alt="title">
			</figure>
		</div>
	</section>
</template>

<script>
    export default {
        props: ["title", "content", "figure", "bg_color", "resp_image", "bg_resp_color"]
    }
</script>

<style lang="scss">
	#block5 {
		background-repeat: no-repeat;
		background-size: cover;
		background-position: center;
		min-height: 500px;
		display: flex;
		align-items: center;

		&.CINZA_ESCURO {

			.article {
				h2 {
					color: #ffffff !important;
				}
			}

		}

		h2 {
			color: #ffffff;
		}

		article {
			width: 45%;
			margin-top: 80px;

			ul {
				li {
					margin-bottom: 10px;
					color: #ffffff;
					font-size: 1.6em;
					font-weight: 100;
					line-height: 24px;
					font-family: 'Ubuntu', 'Arial', 'Tahoma', serif;

					a {
						color: #ffffff;
					}
				}
			}

			p {
				color: #ffffff;
				font-size: 1.6em;
				line-height: 24px;
				margin-bottom: 25px;
				font-weight: 100;
			}
		}

		figure {
			padding: 40px 0;
			text-align: center;
		}
	}

	@media (max-width: 767px) {
		#block5 {
			article {
				width: 100%;
			}

			&.CINZA_ESCURO {
				background-image: none !important;
				background-color: #333333;
				background-position: center;
				padding: 0;

				h2 {
					width: 90%;
					margin: 30px 0 0 30px;
				}

				article {
					width: 90%;
					margin: 60px auto 50px auto;
				}

				figure {
					padding: 0;
				}

				.container {
					padding: 0;
					width: 100%;
				}
			}

			/*&.CINZA_CLARO {
			  background-image: none !important;
			  background-color: #333333;
			  padding: 0;

			  h2 {
				width: 90%;
				margin: 30px 0 0 30px;
			  }

			  article {
				width: 90%;
				margin: 60px auto 50px auto;
			  }

			  figure {
				padding: 0;
			  }

			  .container {
				padding: 0;
				width: 100%;
			  }
			}*/
		}
	}

	@media (max-width: 640px) {
		#block5 {
			article {
				width: 100%;
			}

			&.CINZA_ESCURO {
				background-image: none !important;
				background-color: #333333;
				background-position: center;
				padding: 0;

				h2 {
					width: 90%;
					margin: 30px 0 0 30px;
				}

				article {
					width: 90%;
					margin: 60px auto 50px auto;
				}

				figure {
					padding: 0;

					img {
						width: 100%;
						margin-bottom: -5px;
					}

				}

				.container {
					padding: 0;
					width: 100%;
				}
			}
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/shared/blocks/Block5.vue